import React, { FC } from 'react';
import { PresetStatusColorType } from 'antd/es/_util/colors';

import { useLang } from 'hooks';
import { Tag } from 'components/ui';
import { Override } from 'types/common';
import { TagProps } from 'types/components';
import { InvoiceStatus as EInvoiceStatus } from 'types/models';

const statusColors: Record<EInvoiceStatus, PresetStatusColorType> = {
  [EInvoiceStatus.CONFLICT]: 'warning',
  [EInvoiceStatus.ERROR]: 'error',
  [EInvoiceStatus.EXPIRED]: 'default',
  [EInvoiceStatus.PAID]: 'success',
  [EInvoiceStatus.PENDING]: 'processing',
};

type InvoiceStatusProps = Override<Omit<TagProps, 'color' | 'children'>, {
  status: EInvoiceStatus;
}>;

const InvoiceStatus: FC<InvoiceStatusProps> = ({ status, ...props }) => {
  const lang = useLang();

  return (
    <Tag color={statusColors[status]} {...props}>
      {lang.get(`invoice.statuses.${status.toLowerCase()}`)}
    </Tag>
  );
};

export default InvoiceStatus;
